export const prefixwrap = (userOptions) => {
    const prefix = `.${userOptions.wrapperClassName} `;
    const prefixRegex = new RegExp(`\\.${userOptions.wrapperClassName} `, 'g');
    function onProcessStyle(style, rule, sheet) {
        const parent = rule.options.parent;
        if ([rule.type === 'style' ||
                (parent && parent.type !== 'keyframes')] &&
            rule.selectorText.indexOf(prefix) !== 0) {
            // avoid a edge case where we can have a prfix in the middel of a class
            // like this css ._hy .MuiRadio-colorPrimary-51._hy .MuiRadio-checked-49 { color: rgb(0, 0, 0); }
            rule.selectorText = rule.selectorText.replace(prefixRegex, '');
            rule.selectorText = prefix + rule.selectorText;
        }
        return style;
    }
    return { onProcessStyle: onProcessStyle };
};
